import React,{Component} from "react";

import RenderOptions from "./RenderOptions";
class AddQuestionsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
       
       
      <React.Fragment>
        
        <form>
          <div class="question-form">
            <div class="container">
              <div class="row">
                <div class="col-md-1 col-sm-1" />
                <div class="col-md-11 col-sm-11">
                  <div class="form-group">
                    <label for="ques">Question</label>
                    {this.props.questionBank==false && 
                      <input type="text" id="ques" class="form-control" value={this.props.title} name="title" onChange={this.props.saveInputFields} />
                    }
                    {this.props.questionBank==true && 
                      <select  id="ques" class="form-control"  name="questionId" onChange={this.props.saveInputFields}>
                        {(this.props.questionData).length > 0 &&
                          <RenderOptions
                          questionData={this.props.questionData}
                          />
                        }
                      </select>
                    }
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 col-sm-1" />
                <div class="col-lg-10 col-md-9 col-sm-12">
                  <div class="form-group">
                    <label for="txt">Response</label>
                    <textarea id="txt" class="form-control" value={this.props.response} name="response" onChange={this.props.saveInputFields} />
                  </div>
                </div>
                <div class="col-lg-1 col-md-2">
                  <div class="question-btn">
                    <a onClick={this.props.saveQuestion} href="javascript: void(0);" class="add-btn">
                      Add
                    </a>
                    <a onClick={this.props.resetField} href="javascript: void(0);">
                      <span>Cancel</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  }
}

export default AddQuestionsForm;
